document.addEventListener('DOMContentLoaded', () => {
  const shop = document.querySelector('[data-bundle-shop]');
  if (!shop) return;

  const imageFiles = {
    'Pink Star': 'pink-star.png', 'Rainbow Star': 'rainbow-star.png', 'Purple Star': 'purple-star.png',
    'Gold Star': 'gold-star.png', 'Rainbow Heart': 'rainbow-heart.png', 'Rainbow Butterfly': 'rainbow-butterfly.jpg',
    'Pink Heart': 'pink-heart.png', 'Pink Spiral': 'pink-spiral.png'
  };
  const assetBase = document.getElementById('SelectedWandImage').src.replace(/pink-star\.png.*$/, '');
  const variants = [...document.querySelectorAll('#VariantData span')].map(node => ({
    id: node.dataset.id, name: node.dataset.name, available: node.dataset.available === 'true'
  }));
  const bundles = {1:{price:24.95,shipping:7.95},2:{price:44.95,shipping:7.95},3:{price:59.95,shipping:0},4:{price:74.95,shipping:0}};
  let quantity = 1;
  let selections = [variants[0]];
  const pills = document.getElementById('DesignPills');
  const extras = document.getElementById('ExtraDesigns');
  const message = document.getElementById('BundleMessage');

  variants.forEach((variant, index) => {
    const button = document.createElement('button');
    button.type = 'button'; button.textContent = variant.name; button.disabled = !variant.available;
    button.classList.toggle('active', index === 0);
    button.addEventListener('click', () => selectFirst(variant, button));
    pills.appendChild(button);
  });

  document.querySelectorAll('input[name="bundle"]').forEach(input => input.addEventListener('change', () => setBundle(Number(input.value))));
  document.querySelectorAll('.product-card').forEach(card => card.addEventListener('click', () => {
    const variant = variants.find(item => item.name.toLowerCase() === card.dataset.design.toLowerCase()) || variants[0];
    const button = [...pills.children].find(item => item.textContent === variant.name);
    selectFirst(variant, button);
    document.querySelectorAll('.product-card').forEach(item => item.classList.toggle('active', item === card));
    document.querySelector('.buy-grid').scrollIntoView({behavior:'smooth'});
  }));

  function selectFirst(variant, button) {
    selections[0] = variant;
    [...pills.children].forEach(item => item.classList.toggle('active', item === button));
    document.getElementById('SelectedWandName').textContent = `${variant.name} Wand`;
    document.getElementById('SelectedWandImage').src = `${assetBase}${imageFiles[variant.name] || 'pink-star.png'}`;
    document.getElementById('SelectedWandImage').alt = `${variant.name} wand`;
  }

  function setBundle(next) {
    quantity = next;
    while (selections.length < quantity) selections.push(selections[0]);
    selections = selections.slice(0, quantity);
    document.querySelectorAll('.bundle-option').forEach(option => option.classList.toggle('active', Number(option.querySelector('input').value) === quantity));
    renderExtras(); updateSummary();
  }

  function renderExtras() {
    extras.replaceChildren();
    for (let index = 1; index < quantity; index += 1) {
      const label = document.createElement('label'); label.textContent = `Choose Wand ${index + 1} design`;
      const select = document.createElement('select'); select.setAttribute('aria-label', label.textContent);
      variants.filter(item => item.available).forEach(variant => {
        const option = document.createElement('option'); option.value = variant.name; option.textContent = variant.name;
        option.selected = selections[index].name === variant.name; select.appendChild(option);
      });
      select.addEventListener('change', () => { selections[index] = variants.find(item => item.name === select.value); });
      label.appendChild(select); extras.appendChild(label);
    }
  }

  function updateSummary() {
    const bundle = bundles[quantity];
    document.getElementById('BundlePrice').textContent = `A$${bundle.price.toFixed(2)}`;
    document.getElementById('ShippingNote').textContent = bundle.shipping ? `A$${bundle.shipping.toFixed(2)} shipping` : 'Free shipping';
    document.getElementById('BundleAdd').textContent = `Add ${quantity} ${quantity === 1 ? 'wand' : 'wands'} to bag · A$${bundle.price.toFixed(2)}`;
  }

  document.getElementById('BundleAdd').addEventListener('click', async () => {
    if (shop.dataset.productConfigured !== 'true' || selections.some(item => !item.id)) {
      message.textContent = 'Select your Shopify wand product in the theme editor to activate checkout.'; return;
    }
    const button = document.getElementById('BundleAdd'); button.disabled = true; message.textContent = 'Adding your wands…';
    const bundleName = `${quantity} Wand Bundle`;
    const items = selections.map((variant, index) => ({id:Number(variant.id),quantity:1,properties:{'_Bundle':bundleName,'Wand':String(index + 1)}}));
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      if (!response.ok) throw new Error('Unable to add bundle');
      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (error) { message.textContent = 'This bundle could not be added. Please try again.'; button.disabled = false; }
  });
});
